var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPs1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195,
    height: 154,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D9FFF",
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "m15.583 51.349 42.327-15.57c3.34-1.226 7.116-1.402 11.103-.345l-42.327 15.57c-3.987-1.057-7.764-.881-11.103.345Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0500FF",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "m94.791 71.65 29.836-10.968.726-27.822-29.836 10.977-.726 27.814Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M124.627 60.683 94.791 71.652l21.826 7.947 51.88 18.88-16.26-27.75-27.61-10.046Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0500FF",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M77.207 34.69a14.674 14.674 0 0 0-4.622 2.777c-4.08 3.6-6.7 9.651-6.904 17.345l-.726 27.82 29.836-10.976.726-27.82c.204-7.687 2.825-13.746 6.904-17.346a14.676 14.676 0 0 1 4.622-2.776L77.207 34.691Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "m184.511 125.822-1.12-1.916-14.894-25.426-73.706-26.828-29.836 10.976 21.826 7.947 94.109 34.253a22.86 22.86 0 0 0 3.621.994Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0500FF",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M47.372 45.66a14.678 14.678 0 0 0-4.622 2.777c-4.08 3.6-6.7 9.652-6.904 17.345l-.726 27.821 29.836-10.976.726-27.821c.204-7.687 2.825-13.746 6.904-17.346a14.674 14.674 0 0 1 4.622-2.775L47.372 45.66Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0500FF",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M79.031 11.725c-2.698.994-5.192 2.494-7.418 4.453-6.56 5.791-10.772 15.513-11.09 27.863l-.07 2.621L90.29 35.686l.07-2.62c.254-9.582 2.854-17.579 7.067-23.39l-5.044-2.861-13.35 4.91Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M184.512 125.82a22.164 22.164 0 0 1-3.621-.994l-115.935-42.2L35.12 93.602l21.826 7.947 85.683 31.182 8.426 3.065 1.282-.472c4.72.965 9.574 1.542 11.695.76l21.805-8.017-1.318-2.254-.007.007Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0500FF",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M17.536 56.638a14.678 14.678 0 0 0-4.622 2.776c-4.08 3.6-6.7 9.651-6.904 17.345l-.726 27.821L35.12 93.604l.726-27.822c.204-7.686 2.825-13.744 6.904-17.345a14.678 14.678 0 0 1 4.622-2.775L17.536 56.638Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0500FF",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M41.776 27.149c-6.56 5.79-10.772 15.513-11.09 27.863l-.07 2.62 29.836-10.975.07-2.621c.325-12.343 4.538-22.073 11.09-27.864 2.226-1.958 4.72-3.459 7.418-4.452L49.194 22.696c-2.698.993-5.192 2.494-7.418 4.453Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "m35.28 35.622 55.36-20.367"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M142.621 132.734 35.112 93.605 5.276 104.583l21.826 7.947 94.109 34.253c4.692 1.705 9.123 1.712 12.977.289l29.836-10.976c-3.853 1.416-16.718-1.649-21.41-3.361h.007Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "m184.299 104.579-89.508 32.577m91.807-14.174-65.379 23.791M162.214 90.9l-97.265 35.4m67.43-46.266-97.265 35.401"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "M95.518 43.838 6.01 76.76l89.508-32.922Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M95.518 43.838 6.01 76.76"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#48FF91",
    d: "M95.103 88.103c13.933 0 25.228-11.295 25.228-25.229 0-13.933-11.295-25.229-25.228-25.229-13.934 0-25.229 11.296-25.229 25.23 0 13.933 11.295 25.228 25.229 25.228Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D9FFF",
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "m99.824 56.583 42.327-15.57a7.701 7.701 0 0 0-.782.338l-42.327 15.57c.254-.127.514-.24.782-.338Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M47.253 17.41 89.58 1.84c5.883-2.162 12.653-2.162 19.797.438s13.569 7.32 19.156 13.533c5.016 5.566 9.278 12.301 12.462 19.656l-42.327 15.57c-3.184-7.355-7.446-14.083-12.463-19.656-5.593-6.214-12.138-10.976-19.155-13.534-7.144-2.6-13.914-2.6-19.797-.436Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M98.673 51.03 141 35.46c2.261-.627 4.805-.528 7.468.444 4.509 1.641 8.553 5.474 11.413 10.321 2.423 4.107 4.016 8.968 4.347 13.858l-42.327 15.57c-.338-4.89-1.924-9.75-4.347-13.858-2.853-4.847-6.904-8.68-11.413-10.321-2.663-.965-5.207-1.071-7.468-.444Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M186.182 79.273c-5.199-8.82-12.547-15.795-20.783-18.796a28.788 28.788 0 0 0-1.17-.395l-42.327 15.57c.388.12.775.253 1.17.394 8.236 3.001 15.584 9.976 20.783 18.797 5.213 8.827 8.306 19.564 8.024 30.04-.267 10.483-3.86 18.782-9.433 23.679a19.837 19.837 0 0 1-6.305 3.79l42.327-15.57a19.837 19.837 0 0 0 6.305-3.79c5.573-4.903 9.159-13.195 9.434-23.679.281-10.476-2.819-21.213-8.025-30.04Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#48FF91",
    d: "M143.854 94.845c5.214 8.827 8.307 19.564 8.025 30.04-.268 10.483-3.861 18.782-9.434 23.679-5.565 4.917-13.139 6.453-21.367 3.459l-94.11-34.254-25.947-9.44.867-33.063c.24-9.123 3.36-16.345 8.208-20.614 4.382-3.868 10.208-5.333 16.584-3.642.838-12.597 5.41-22.566 12.28-28.618 7.312-6.453 17.267-8.475 28.081-4.544 7.017 2.558 13.57 7.32 19.156 13.534 5.016 5.566 9.279 12.3 12.463 19.656 2.261-.627 4.805-.528 7.468.444 4.509 1.641 8.553 5.474 11.413 10.32 2.423 4.108 4.016 8.97 4.347 13.859.387.12.775.253 1.169.394 8.236 3.001 15.584 9.976 20.783 18.797l.014-.007Zm-4.22 48.956c4.805-4.248 7.891-11.371 8.13-20.41.233-9.053-2.423-18.268-6.918-25.89-4.502-7.63-10.814-13.619-17.916-16.204a22.864 22.864 0 0 0-2.881-.839l-2.325-.514.106-2.959c.12-4.516-1.142-8.898-3.29-12.54-2.149-3.635-5.15-6.489-8.539-7.722-2.564-.937-4.946-.803-6.96.198l-1.811.894-1.071-2.74c-2.924-7.468-7.095-14.323-12.097-19.882-5.009-5.551-10.842-9.806-17.14-12.103-9.687-3.523-18.571-1.712-25.137 4.058-6.56 5.791-10.772 15.513-11.09 27.863l-.07 2.621-2.057-.747c-6.038-2.19-11.561-1.07-15.654 2.53-4.08 3.6-6.7 9.651-6.905 17.345l-.725 27.821 21.826 7.947 94.108 34.253c7.102 2.586 13.605 1.261 18.423-2.98"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0500FF",
    d: "m121.217 146.774-6.326-2.303-1.973 4.579 8.158 2.973c2.396.874 4.735 1.346 6.982 1.48l2.388-5.545c-2.881.352-5.995 0-9.229-1.184Zm22.636-51.93a53.288 53.288 0 0 0-4.699-6.735l-1.825 4.242a47.05 47.05 0 0 1 3.523 5.15 51.102 51.102 0 0 1 5.509 13.505l2.388-5.552a58.584 58.584 0 0 0-4.896-10.602v-.008Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F7",
    d: "m114.193 57.187 42.327-15.57c-2.022-2.254-4.347-4.065-6.833-5.206l-42.328 15.57c2.487 1.148 4.812 2.952 6.834 5.206Zm51.198 3.29a28.75 28.75 0 0 0-1.169-.395l-42.327 15.57c.387.12.774.253 1.169.394 5.862 2.135 11.272 6.292 15.774 11.681l42.327-15.57c-4.509-5.396-9.912-9.546-15.774-11.68Zm20.788 18.799A51.55 51.55 0 0 0 184.087 76L141.76 91.57a54.1 54.1 0 0 1 2.092 3.276c.331.556.648 1.12.965 1.698l42.327-15.57a50.51 50.51 0 0 0-.965-1.698ZM109.376 2.278A33.4 33.4 0 0 0 104.86.975l-42.327 15.57c1.487.323 2.994.753 4.516 1.303 4.692 1.705 9.166 4.403 13.294 7.862l42.327-15.57c-4.121-3.452-8.602-6.15-13.294-7.862Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M47.253 17.41 89.58 1.84c5.883-2.162 12.653-2.162 19.797.438s13.569 7.32 19.156 13.533c5.016 5.566 9.278 12.301 12.462 19.656l-42.327 15.57c-3.184-7.355-7.446-14.083-12.463-19.656-5.593-6.214-12.138-10.976-19.155-13.534-7.144-2.6-13.914-2.6-19.797-.436Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M98.673 51.03 141 35.46c2.261-.627 4.805-.528 7.468.444 4.509 1.641 8.553 5.474 11.413 10.321 2.423 4.107 4.016 8.968 4.347 13.858l-42.327 15.57c-.338-4.89-1.924-9.75-4.347-13.858-2.853-4.847-6.904-8.68-11.413-10.321-2.663-.965-5.207-1.071-7.468-.444Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M186.182 79.273c-5.199-8.82-12.547-15.795-20.783-18.796a29.28 29.28 0 0 0-1.169-.395l-42.328 15.57c.388.12.775.253 1.17.394 8.236 3.001 15.584 9.976 20.783 18.797 5.213 8.827 8.306 19.564 8.024 30.04-.267 10.483-3.86 18.782-9.433 23.679a19.837 19.837 0 0 1-6.305 3.79l42.327-15.57a19.837 19.837 0 0 0 6.305-3.79c5.573-4.903 9.159-13.195 9.434-23.679.281-10.476-2.819-21.213-8.025-30.04Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.539,
    d: "M139.634 143.801c4.805-4.248 7.891-11.371 8.13-20.41.233-9.053-2.423-18.268-6.918-25.89-4.502-7.63-10.814-13.619-17.916-16.204a22.864 22.864 0 0 0-2.881-.839l-2.325-.514.106-2.959c.12-4.516-1.142-8.898-3.29-12.54-2.149-3.635-5.15-6.489-8.539-7.722-2.564-.937-4.946-.803-6.96.198l-1.811.894-1.071-2.74c-2.924-7.468-7.095-14.323-12.097-19.882-5.009-5.551-10.842-9.806-17.14-12.103-9.687-3.523-18.571-1.712-25.137 4.058-6.56 5.791-10.772 15.513-11.09 27.863l-.07 2.621-2.057-.747c-6.038-2.19-11.561-1.07-15.654 2.53-4.08 3.6-6.7 9.651-6.905 17.345l-.725 27.821 21.826 7.947 94.108 34.253c7.102 2.586 13.605 1.261 18.423-2.98m4.213-48.956c5.214 8.827 8.307 19.564 8.025 30.04-.268 10.483-3.861 18.782-9.434 23.679-5.565 4.917-13.139 6.453-21.367 3.459l-94.11-34.254-25.947-9.44.867-33.063c.24-9.123 3.36-16.345 8.208-20.614 4.382-3.868 10.208-5.333 16.584-3.642.838-12.597 5.41-22.566 12.28-28.618 7.312-6.453 17.267-8.475 28.081-4.544 7.017 2.558 13.57 7.32 19.156 13.534 5.016 5.566 9.279 12.3 12.463 19.656 2.261-.627 4.805-.528 7.468.444 4.509 1.641 8.553 5.474 11.413 10.32 2.423 4.108 4.016 8.97 4.347 13.859.387.12.775.253 1.169.394 8.236 3.001 15.584 9.976 20.783 18.797l.014-.007Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#0500FF",
    d: "m27.11 112.52-14.055-5.115-1.973 4.579 15.887 5.784 10.187 3.706 1.973-4.579-12.02-4.375Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 93.462,
    x2: 112.815,
    y1: 24.744,
    y2: 74.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#46F997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#42EAA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3AD0C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#31ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 136.639,
    x2: 130.39,
    y1: 70.207,
    y2: 50.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#46F997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#42EAA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3AD0C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#31ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 154.338,
    x2: 163.398,
    y1: 97.393,
    y2: 120.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#46F997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#42EAA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3AD0C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#31ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPs1);
export default __webpack_public_path__ + "static/media/ps-1.d6fda9238f208d9a6774eea26facaf50.svg";
export { ForwardRef as ReactComponent };